module.exports = __webpack_public_path__ + "img/default-mobile-english.794da03a.png";